import { render, staticRenderFns } from "./NewsLetters.vue?vue&type=template&id=33c3cac7&"
import script from "./NewsLetters.vue?vue&type=script&lang=js&"
export * from "./NewsLetters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports